var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cursor-pointer w-20 h-20 flex items-center justify-center rounded-full",class:{
      'bg-primary-color': !_vm.getPrimaryColor,
      [`bg-[${_vm.getPrimaryColor}]`]: _vm.getPrimaryColor
  }},[_c('FontAwesomeIcon',{staticClass:"relative left-0.5 z-20 size-10! text-white",attrs:{"icon":"play"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }